import {
  OriginalSchedulesMenu,
  NewSchedulesMenu,
} from 'constant/ScheduleMenuConstant';

const RouterService = {
  isValidUrl(url) {
    const validUrls = [
      '/',
      '/organisation',
      '/email-triggers',
      '/report/history',
      '/report/configurations',
      '/architecture',
      '/break-patterns',
      '/channel-profiles',
      '/library/title-groups',
      '/prioritisation',
      '/title-exclusions',
      '/attributes-override',
      '/schedule',
      '/scheduledetails',
      '/submitted',
      '/export',
      '/users',
      '/channel-groups',
      '/business-rules',
      '/custom-business-rules',
      '/channels',
      '/access-denied',
      '/not-found',
      '/request-timed-out',
      '/maintenance',
      '/profile',
      '/playlist',
      '/view-schedules',
      '/inclusion',
      '/library/programs',
      '/rights',
      '/library/interstitials',
      '/content-types',
      '/library/commercials',
      '/advanced-schedule',
      '/standby-schedule',
      '/presentation-schedule',
      '/notifications',
      '/monitoring',
      '/new-unified-schedule',
      '/advanced-unified-schedule',
    ];
    return isAccessible(validUrls, url);
  },
  isAccessibleForSuperAdmin(url) {
    const accessiblePages = [
      '/',
      '/users',
      '/organisation',
      '/channel-groups',
      '/channels',
      '/business-rules',
      '/custom-business-rules',
      '/email-triggers',
      '/report/history',
      '/report/configurations',
      '/access-denied',
      '/not-found',
      '/request-timed-out',
      '/maintenance',
      '/profile',
    ];
    return isAccessible(accessiblePages, url);
  },

  isAccessibleForOrganisationalAdmin(url) {
    const accessiblePages = [
      '/',
      '/architecture',
      '/break-patterns',
      '/channel-profiles',
      '/library/title-groups',
      '/prioritisation',
      '/title-exclusions',
      '/attributes-override',
      '/schedule',
      '/scheduledetails',
      '/submitted',
      '/export',
      '/users',
      '/channel-groups',
      '/channels',
      '/access-denied',
      '/not-found',
      '/request-timed-out',
      '/maintenance',
      '/profile',
      '/playlist',
      '/view-schedules',
      '/inclusion',
      '/library/programs',
      '/rights',
      '/library/interstitials',
      '/content-types',
      '/organisation',
      '/library/commercials',
      '/advanced-schedule',
      '/standby-schedule',
      '/presentation-schedule',
      '/notifications',
      '/monitoring',
      '/new-unified-schedule',
      '/advanced-unified-schedule',
    ];
    return isAccessible(accessiblePages, url);
  },

  isAccessibleForOrganisationalUser(url) {
    const accessiblePages = [
      '/',
      '/architecture',
      '/break-patterns',
      '/channel-profiles',
      '/library/title-groups',
      '/prioritisation',
      '/title-exclusions',
      '/attributes-override',
      '/schedule',
      '/scheduledetails',
      '/submitted',
      '/export',
      '/access-denied',
      '/not-found',
      '/request-timed-out',
      '/maintenance',
      '/profile',
      '/playlist',
      '/view-schedules',
      '/inclusion',
      '/library/programs',
      '/rights',
      '/library/interstitials',
      '/content-types',
      '/organisation',
      '/library/commercials',
      '/advanced-schedule',
      '/standby-schedule',
      '/presentation-schedule',
      '/notifications',
      '/monitoring',
      '/new-unified-schedule',
      '/advanced-unified-schedule',
    ];
    return isAccessible(accessiblePages, url);
  },

  isNotAccessibleForUser(url, scheduleViewType) {
    const inaccessiblePagesForOriginalScheduleMenuType = [
      '/export',
      '/advanced-schedule',
      '/standby-schedule',
      '/presentation-schedule',
    ];

    const inaccessiblePagesForNewScheduleMenuType = [
      '/schedule',
      '/view-schedules',
    ];

    if (scheduleViewType === OriginalSchedulesMenu) {
      return isNotAccessible(inaccessiblePagesForOriginalScheduleMenuType, url);
    }

    if (scheduleViewType === NewSchedulesMenu) {
      return isNotAccessible(inaccessiblePagesForNewScheduleMenuType, url);
    }
  },
};
const isAccessible = (accessiblePages, url) => {
  return (
    accessiblePages.includes(url) ||
    url.includes('/internal-server') ||
    url.includes('/passwordreset')
  );
};

const isNotAccessible = (inAccessiblePages, url) => {
  return inAccessiblePages.includes(url);
};
export default RouterService;
